/**
 * THIS FILE IS AUTOGENERATED. DO NOT EDIT.
 * To regenerate these files after changing A/B test configs, run this command:
 * `npm run generate-ab-tests`
 */

import {
  __abTest_base,
  __useAbTest_base,
  __inWinnerHoldout_base,
} from 'js/ab_tests/ab_test';

const TEST_CONFIG = {
  active: false,
  finished: false,
  alternatives: [
    'control',
    'variant_b1',
    'variant_b2',
    'variant_b3',
    'variant_b4',
    'variant_b5',
    'variant_b6',
    'variant_c1',
    'variant_c2',
    'variant_c3',
    'variant_d1',
    'variant_d2',
    'variant_d3',
    'variant_f1',
    'variant_f2',
    'variant_f4',
    'variant_f5',
    'variant_h1',
    'variant_h2',
    'variant_h3',
  ],
} as const;

/**
 * Synchronously returns the variant for this A/B test:
 * loswp_modal_autotest_2026_q2
 *
 * Returns the bucket based on the current logged-in user id.
 * This function also makes a call to the server to bucket
 * the user server-side, but does not return the response.
 *
 * Once a user is bucketed, their variant for the test
 * is stored in `sessionStorage`, which we check to avoid
 * making duplicate bucketing calls to the server.
 * `sessionStorage` is cleared when the user closes their tab.
 */
export function abTest() {
  return __abTest_base('loswp_modal_autotest_2026_q2', TEST_CONFIG);
}

/**
 * React hook to return the bucket for this A/B test:
 * loswp_modal_autotest_2026_q2
 *
 * Returns the bucket based on the current logged-in user id.
 * Asynchronously records the test on the backend.
 */
export function useAbTest() {
  return __useAbTest_base('loswp_modal_autotest_2026_q2', TEST_CONFIG);
}

/**
 * Returns whether the user is in the winner holdout for this A/B test:
 * loswp_modal_autotest_2026_q2
 *
 * Returns true if all of the following are true:
 * - The test is finished
 * - The user is in the overall holdout
 * - The user is in the winner sub-holdout
 */
export function inWinnerHoldout() {
  return __inWinnerHoldout_base('loswp_modal_autotest_2026_q2', TEST_CONFIG);
}

// MD5 hash of test's YAML config; modification will fail commit hook
// 4d4a42078f52dc72cff63f253b78e16d
